module.exports = __webpack_public_path__ + "img/p6.71044f8.jpg";